const ONBOARDING_TOUR_GUIDE = {
  ASC: 'https://app.supademo.com/embed/cm5m732u40245guygp2pa6g0i?embed_v=2',
  QBFS: 'https://app.supademo.com/embed/cm5m5g4i201f2guyg7rgxbbu7?embed_v=2',
  CSV: 'https://app.supademo.com/embed/cm5m3cyqx00vzguygi8mackkt?embed_v=2',
  SFY: 'https://demo.inventoryoptimizer.ai/embed/cmbetp42837j3sn1resai4bqr?embed_v=2',
};

const APP_OVERVIEW_TOUR_GUIDE = {
  ASC: 'https://app.supademo.com/embed/cm5geedee03at5ubau93lcvmk?embed_v=2',
  QBFS: 'https://app.supademo.com/embed/cm5559m6a2ictvlrymo1d8672?embed_v=2',
  CSV: 'https://demo.inventoryoptimizer.ai/embed/cm7iv04e5061fil1lpyhgrxfz?embed_v=2',
  SFY: 'https://demo.inventoryoptimizer.ai/embed/cmb7qgtvc4xywppkp9bukheqn?embed_v=2'
};

const UPLOAD_ITEM_TOUR_GUIDE = {
  ASC: 'https://app.supademo.com/embed/cm5gkmlk8050a5ubaaxwq9hnl?embed_v=2',
  CSV: 'https://app.supademo.com/embed/cm5kv16sw05yb7lw040uukt8a?embed_v=2',
  QBFS: 'https://app.supademo.com/embed/cm5eyw11l4flfvlrydq0pcd2z?embed_v=2',
  SFY: 'https://demo.inventoryoptimizer.ai/embed/cmbytw4aeh0ewsn1ra67drnps?embed_v=2'
};

const CREATE_SUPPLIER_TOUR_GUIDE = {
  ASC: 'https://app.supademo.com/embed/cm5ktcoc5059m7lw06qw5gduc?embed_v=2',
  CSV: 'https://app.supademo.com/embed/cm5kxj1b706zl7lw0wgy6dggy?embed_v=2',
  QBFS: 'https://app.supademo.com/embed/cm5f03z004gtsvlryxxmy6cf4?embed_v=2',
  SFY: 'https://app.supademo.com/embed/cmbune1zvf5rksn1rhyofkc8t?embed_v=2'
};

const MY_SUGGESTED_TOUR_GUIDE = {
  ASC: 'https://app.supademo.com/embed/cm5g9f87e01sr5ubab671on1c?embed_v=2',
  QBFS: 'https://app.supademo.com/embed/cm54snzmy2fpevlryibycfdd5?embed_v=2',
  SFY: 'https://demo.inventoryoptimizer.ai/embed/cmdmmgapw2ere1c4cwj1w8g14?embed_v=2',
};

const CUSTOM_TOUR_GUIDE = {
  ASC: 'https://app.supademo.com/embed/cm5gito2s045r5ubau9ktr8qz?embed_v=2',
  QBFS: 'https://app.supademo.com/embed/cm55148sn2hcavlry0vq5dncf?embed_v=2',
  SFY: 'https://demo.inventoryoptimizer.ai/embed/cmcu9isb11sir9st8rn9rka1q?embed_v=2',
};

const CREATE_SHIPMENT_TOUR_GUIDE = {
  ASC: 'https://app.supademo.com/embed/cm5krr1ds04sp7lw0rxqscuta?embed_v=2',
};

const COMPANY_DETAILS_TOUR_GUIDE = {
  ASC: 'https://demo.inventoryoptimizer.ai/embed/cm7kbx3lm0k31ddumpdn6pj4e?embed_v=2',
  CSV: 'https://demo.inventoryoptimizer.ai/embed/cm7skbx371dcyhilgxi1o3dxp?embed_v=2',
  QBFS: 'https://demo.inventoryoptimizer.ai/embed/cm7n3luxg2bhyddumr8r674pn?embed_v=2',
  SFY: 'https://demo.inventoryoptimizer.ai/embed/cmbru1d92cojksn1rmndwlyd2?embed_v=2',
};

const WAREHOUSE_TOUR_GUIDE = 
{
  CSV: 'https://demo.inventoryoptimizer.ai/embed/cm7suq5it1icyhilgo0z7ojdj?embed_v=2'
}

const EDIT_ITEMS_HISTORY_TOUR_GUIDE = {
  ASC: 'https://demo.inventoryoptimizer.ai/embed/cm6osbfto05ufagqw5rkasznq?embed_v=2',
  CSV: 'https://demo.inventoryoptimizer.ai/embed/cm6q6734104flkvxy8eg2vdws?embed_v=2',
  QBFS: 'https://demo.inventoryoptimizer.ai/embed/cm6t4km10015yjcj8e4omqtmz?embed_v=2',
  SFY: 'https://demo.inventoryoptimizer.ai/embed/cmclrd4is0pln16b6aw2x1453?embed_v=2',
};

const MODIFY_FORECAST_TOUR_GUIDE = {
  ASC: 'https://demo.inventoryoptimizer.ai/embed/cm78p9ol501sx11on64hqfqec?embed_v=2',
  CSV: 'https://demo.inventoryoptimizer.ai/embed/cm7aa28kc0uxl11onicy72vjm?embed_v=2',
  QBFS: 'https://demo.inventoryoptimizer.ai/embed/cm7a6c8vn0sdi11ongf1zxmai?embed_v=2',
  SFY: 'https://demo.inventoryoptimizer.ai/embed/cmclsai8l0qrt16b6c0i44xgf?embed_v=2',
};

const PURCHASE_ORDERS_TOUR_GUIDE = {
  SFY: 'https://demo.inventoryoptimizer.ai/embed/cmc8r55b602l58qszezus27vb?embed_v=2'
};

const CREATE_KITS_TOUR_GUIDE = {
  SFY: 'https://demo.inventoryoptimizer.ai/embed/cmcad0cx01lk68qszg8ht3jci?embed_v=2',
}

const MANAGE_PO_VAULT_TOUR_GUIDE = {
  SFY: 'https://demo.inventoryoptimizer.ai/embed/cmdin770a0p8k1c4cvnonkxtk?embed_v=2',
}

const ITEM_REPRICING_TOUR_GUIDE: Record<string, string> = {
  ASC: 'https://demo.inventoryoptimizer.ai/embed/cmnpva5n98u4yabur53yiupqr?embed_v=2',
}

const CAMPAIGN_PRODUCT_ADS_TOUR_GUIDE = {
  ASC: 'https://demo.inventoryoptimizer.ai/embed/cmosfwkph5od9w9dosihqq3bu?embed_v=2',
}

export {
  ONBOARDING_TOUR_GUIDE,
  APP_OVERVIEW_TOUR_GUIDE,
  UPLOAD_ITEM_TOUR_GUIDE,
  CREATE_SUPPLIER_TOUR_GUIDE,
  MY_SUGGESTED_TOUR_GUIDE,
  CUSTOM_TOUR_GUIDE,
  CREATE_SHIPMENT_TOUR_GUIDE,
  COMPANY_DETAILS_TOUR_GUIDE,
  WAREHOUSE_TOUR_GUIDE,
  EDIT_ITEMS_HISTORY_TOUR_GUIDE,
  MODIFY_FORECAST_TOUR_GUIDE,
  PURCHASE_ORDERS_TOUR_GUIDE,
  CREATE_KITS_TOUR_GUIDE,
  MANAGE_PO_VAULT_TOUR_GUIDE,
  ITEM_REPRICING_TOUR_GUIDE,
  CAMPAIGN_PRODUCT_ADS_TOUR_GUIDE
};
